
import { $SCOPE_SERVICE_NAME } from '../../../services/system'

import { i18n } from '../../common/i18n/common.i18n'

//#region Asset Imports

import './cookie-banner.scss'
import * as TEMPLATE from './cookie-banner.tpl.html'

//#endregion

export interface CookieBannerScope extends ng.IScope {
    bannerHidden: boolean
    message: string
    acceptText: string

    accept()
}

export class CookieBannerDirective implements ng.IDirective {
    protected keyAccepted = 'SIMAX-cl'
    protected valueAccepted = 'accepted'
    protected expireDays = 365

    restrict = 'E'

    controller = [$SCOPE_SERVICE_NAME, '$cookies', ($scope: CookieBannerScope, $cookies: ng.cookies.ICookiesService) => {

        $scope.bannerHidden = true;

        var t = $cookies.get(this.keyAccepted)

        $scope.bannerHidden = $cookies.get(this.keyAccepted) === this.valueAccepted
        $scope.message = i18n('Common', 'CookiesLawMessage')
        $scope.acceptText = i18n('Common', 'Understand')

        var cookieAccept = () => {
            var expireDate = new Date();
            expireDate.setTime(expireDate.getTime() + (this.expireDays * 24 * 60 * 60 * 1000));
            $cookies.put(this.keyAccepted, this.valueAccepted, { expires: expireDate })

            $scope.bannerHidden = true
        }

        $scope.accept = cookieAccept

    }]

    template = TEMPLATE
    replace = true

}